import OverviewContainer from "./OverviewContainer";
import OverviewStore from "./OverviewStore";

export default OverviewStore(OverviewContainer);
